'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'frog';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'f52e';
var svgPathData = 'M368 64c-26.5 0-48 21.5-48 48 0 .6 0 1.1-.1 1.7-.9 8-7.6 14.3-15.9 14.3l-3.2 0C152.3 128 32 248.3 32 396.8L32 416c0 17.7 14.3 32 32 32l272 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0c-4.1 0-8.2-1.6-11.3-4.7-6.2-6.2-6.2-16.4 0-22.6l8.8-8.8c1.7-1.7 3.2-3.4 4.7-5.3 8.9-11.1 13.8-25 13.8-39.4 0-12.5-3.7-24.2-9.9-34-11.2-17.5-30.9-29.1-53.3-29.1-16.8 0-32.8 6.7-44.7 18.5l-40.8 40.8c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l40.8-40.8c17.9-17.9 42.1-27.9 67.3-27.9 20.7 0 39.9 6.6 55.5 17.9 24 17.3 39.7 45.5 39.7 77.3 0 17.4-4.7 34.2-13.5 48.9 25.3 1.3 45.5 22.3 45.5 47.9 0 26.5-21.5 48-48 48L64 480c-35.3 0-64-28.7-64-64l0-19.2c0-162.4 128.6-294.7 289.6-300.6 7.3-36.6 39.7-64.2 78.4-64.2 41.4 0 75.4 31.4 79.6 71.7 38.1 7.3 69.1 18.5 90.1 27.6 24.9 10.7 38.3 35.5 38.3 60.8 0 25.5-13.4 49.1-35.2 62.2L423.7 324.4 519.8 448 560 448c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0c-4.9 0-9.6-2.3-12.6-6.2l-112-144c-2.8-3.6-3.9-8.3-3.1-12.8s3.6-8.4 7.5-10.8l132.6-79.5c12.2-7.3 19.7-20.5 19.7-34.7 0-14.4-7.5-26.4-19-31.4-21.5-9.3-54.8-21.1-95.7-27.7-8.2-1.3-14.1-8.7-13.4-17.1 .1-1.3 .2-2.6 .2-3.9 0-26.5-21.5-48-48-48zm0 32a16 16 0 1 1 0 32 16 16 0 1 1 0-32z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFrog = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;